import { VirtualBackgroundItem } from 'features/virtual-backgrounds/types';

const isSameBackground = (a: VirtualBackgroundItem, b: VirtualBackgroundItem) =>
  a.id === b.id || (a.type === b.type && a.value === b.value);

/**
 * Merges SDK-supplied backgrounds into the existing list, letting an incoming item replace the
 * background it collides with — by id, or by pointing at the same source — instead of duplicating
 * it. The replacement keeps the position of the background it replaced.
 */
export const mergeVirtualBackgrounds = (
  existing: VirtualBackgroundItem[],
  incoming: VirtualBackgroundItem[]
): VirtualBackgroundItem[] =>
  incoming.reduce<VirtualBackgroundItem[]>(
    (merged, background) => {
      const position = merged.findIndex((item) => isSameBackground(item, background));

      if (position === -1) {
        return [...merged, background];
      }

      merged[position] = background;

      return merged;
    },
    [...existing]
  );
